import React, { type FC } from 'react';
import css from '../TemplatePage.scss';
import { TextButton } from '@wix/design-system';
import { ChevronLeft } from '@wix/wix-ui-icons-common';
import { usePageNavigate } from '../../../hooks/usePageNavigate';
import { DataHooks } from '../../../constants/dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';
import { useTemplatesData } from '../../../hooks/useTemplatesData';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';

export const BackCrumb: FC = () => {
  const { navigateToMainPage } = usePageNavigate();
  const { t } = useTranslation();
  const { currentTemplate: template } = useTemplatesData();

  const { reportBreadCrumbsClicked } = useTemplatesPageBi();
  const onBreadCrumbsClicked = () => {
    reportBreadCrumbsClicked(template.id);
    navigateToMainPage();
  };

  return (
    <div
      data-hook={DataHooks.BackCrumb}
      className={css.breadcrumbWrapper}
      onClick={onBreadCrumbsClicked}
    >
      <TextButton
        skin="dark"
        size="small"
        weight="normal"
        prefixIcon={<ChevronLeft className={css.breadcrumbIcon} />}
        className={css.breadcrumbText}
        dataHook={DataHooks.BackCrumbText}
      >
        {t('app.template-page.back-crumb')}
      </TextButton>
    </div>
  );
};
